import MantenimientoTemplate from "../components/templates/MantenimientoTemplate"

const Mantenimiento = () => {
    return <MantenimientoTemplate/>;
};

export default Mantenimiento;